import React from 'react';

const Features = () => {
  const features = [
    {
      icon: 'fas fa-upload',
      title: 'Easy Upload',
      description: 'Upload your purses in seconds with our simple interface'
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Safe Trading',
      description: 'Safe and Secure Trading System, view contact us page for questions'
    },
    {
      icon: 'fas fa-calendar-alt',
      title: 'Flexible Duration',
      description: 'Choose your trade duration from 3 days to 30 days'
    },
    {
      icon: 'fas fa-users',
      title: 'Community',
      description: 'Connect with purse enthusiasts worldwide'
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <div className="feature-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <i className={feature.icon}></i>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features; 